import { render, staticRenderFns } from "./VersionFail.vue?vue&type=template&id=42f59b33&"
import script from "./VersionFail.vue?vue&type=script&lang=js&"
export * from "./VersionFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports